import React, { useState, useEffect } from 'react';
import { IoMdEye } from 'react-icons/io';
import { Button, Pagination } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ViewWeightDisputes from '../../../component/b2c/models/viewWeightDisputes';
import { useMyContext } from '../../../context/MyContext';
import Sidebar from '../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../component/b2c/navBar/navBar';
import PaginationItem from '@mui/material/PaginationItem';
import '../../../css/custom-scrollbar.css';
import { FaWeight } from 'react-icons/fa'
import { MdCheckCircle, MdCancel } from "react-icons/md";
import axios from 'axios';
import { FaDownload } from "react-icons/fa";
import { toast } from 'react-toastify';
import { dispute_action_admin, Base_Url, weightList } from '../../../config/config';

const AllWeightDisputes = () => {
    const [totalOrders, setTotalOrders] = useState(0);
    const { isDarkMode } = useMyContext();
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const { isToggleSidebar } = useMyContext();
    const [weights, setweights] = useState([]);
    const [selectedweight, setSelectedweight] = useState(null);
    const navigate = useNavigate();

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);

    useEffect(() => {
        fetchAllDisputes();
    }, [page, limit]);

    // CSV Download functionality
    const downloadCSV = () => {
        if (!weights || weights.length === 0) {
            toast.error("No data available to download");
            return;
        }

        // Define CSV headers
        const headers = [
            "Seller ID",
            "Waybill",
            "Initial Weight",
            "Dimension",
            "Product Description",
            "SKU",
            "Reversed Weight",
            "Price",
            "Status",
            "Date"
        ];

        // Convert data to CSV format
        const csvData = weights.map(weight => [
            weight.seller_id || '',
            weight.waybill || '',
            weight.initial_weight || '',
            weight.dimension || '',
            weight.product_des || '',
            weight.sku || '',
            weight.reversed_weight || '',
            weight.price || '',
            weight.status || '',
            weight.timestamp || ''
        ]);

        // Add headers to the beginning
        csvData.unshift(headers);

        // Convert to CSV string
        const csvContent = csvData.map(row =>
            row.map(field => {
                // Handle fields that might contain commas or quotes
                const stringField = String(field);
                if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
                    return `"${stringField.replace(/"/g, '""')}"`;
                }
                return stringField;
            }).join(',')
        ).join('\n');

        // Create and download file
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `weight_disputes_${new Date().toISOString().split('T')[0]}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast.success("CSV file downloaded successfully!");
    };

    const handleAccept = async (row) => {
        const token = localStorage.getItem('token');
        const cus_id = localStorage.getItem('cus_id');
        const formData = new FormData();
        formData.append("waybill", row.waybill);
        formData.append("status", "Accept");
        formData.append("seller_id", row.seller_id);

        try {
            const response = await axios.post(Base_Url + dispute_action_admin, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    'token': token,
                    'cus_id': cus_id,
                },
            });
            if (response.data.status === "SUCCESS") {
                toast.success(response.data.message);
                fetchAllDisputes(); // Refresh data after action
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error("Error uploading data: " + error.message);
        }
    };

    const handleReject = async (row) => {
        const token = localStorage.getItem('token');
        const cus_id = localStorage.getItem('cus_id');

        const formData = new FormData();
        formData.append("waybill", row.waybill);
        formData.append("status", "Raise");
        formData.append("seller_id", row.seller_id);

        try {
            const response = await axios.post(Base_Url + dispute_action_admin, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    'token': token,
                    'cus_id': cus_id,
                },
            });
            if (response.data.status === "SUCCESS") {
                toast.success(response.data.message);
                fetchAllDisputes(); // Refresh data after action
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error("Error uploading data: " + error.message);
        }
    };

    const fetchAllDisputes = async () => {
        const token = localStorage.getItem('token');
        const cusid = localStorage.getItem('cus_id');
        try {
            const pageNumber = Number(page) || 1;
            const limitNumber = Number(limit) || 10;
            const urlweight = `${Base_Url}${weightList}?page=${pageNumber}&limit=${limitNumber}`;
            const response = await fetch(urlweight, {
                method: 'GET',
                headers: {
                    token,
                    cus_id: cusid,
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status === "SUCCESS") {
                setweights(result.data);
                setTotalOrders(result.pagination.total_records);
            } else {
                toast.error(result.message || 'Failed to fetch weight disputes.');
            }
        } catch (error) {
            // toast.error('Something went wrong!');
        }
    };

    const handlePaginationChange = (event, value) => {
        setPage(value);
    };

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
        setPage(1);
    };

    const handleViewClick = (weight) => {
        setSelectedweight(weight);
        setIsPopupOpen(true);
    };

    const handleClose = () => {
        setIsPopupOpen(false);
    };

    const handleNavigation = () => {
        navigate('/dashboard');
    };

    return (
        <>
            <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
                <div className="z-10">
                    <NavBar />
                </div>

                <div className="flex flex-1 overflow-hidden">
                    {isToggleSidebar && (
                        <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
                            style={
                                window.innerWidth < 768
                                    ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                                    : {}
                            }>
                            <Sidebar />
                        </div>
                    )}

                    <div className={`shadow-custom-light overflow-x-hidden ml-4 custom-scrollbar mt-6 mb-6 mr-6 w-full rounded-custom overflow-y-auto dark:shadow-custom-dark p-4 ${isDarkMode ? 'dark:bg-darkmodeColor text-white' : ''}`}>

                        <div className="flex flex-col sm:flex-row items-center gap-4 mb-4 sm:mb-6">
                            <button
                                onClick={handleNavigation}
                                className="text-xl w-full sm:w-[100%] lg:min-w-[500px] sm:text-2xl font-bold bg-customPurple hover:bg-purple-700 text-white font-sans px-8 py-2 rounded h-[48px] flex items-center justify-center"
                            >
                                <FaWeight className="mr-2" size={24} />
                                All Weight Disputes
                            </button>

                            <button
                                onClick={downloadCSV}
                                className="bg-green-600 hover:bg-green-700  w-full text-white font-medium px-4 py-2 rounded h-[47px] flex items-center justify-center transition-colors duration-200 shadow-md hover:shadow-lg whitespace-nowrap"
                                disabled={!weights || weights.length === 0}
                            >
                                <FaDownload className="mr-2" size={16} />
                                Download CSV
                            </button>
                        </div>

                        <div className="overflow-x-auto rounded-xl custom-scrollbar">
                            <table className="min-w-full table-auto custom-scrollbar overflow-y-auto">
                                <thead className='bg-customPurple text-white text-[10px] dark:bg-darkmodeColor dark:text-white'>
                                    <tr>
                                        <th className='p-2 text-left font-medium'>Seller ID</th>
                                        <th className='p-2 text-left font-medium'>Waybill</th>
                                        <th className='p-2 text-left font-medium'>Initial Weight</th>
                                        <th className='p-2 text-left font-medium'>Dimension</th>
                                        <th className='p-2 text-left font-medium'>Product</th>
                                        <th className='p-2 text-left font-medium'>SKU</th>
                                        <th className='p-2 text-left font-medium'>Reversed Weight</th>
                                        <th className='p-2 text-left font-medium'>Price</th>
                                        <th className='p-2 text-left font-medium'>Status</th>
                                        <th className='p-2 text-left font-medium'>Date</th>
                                        <th className='p-2 text-left font-medium'>Action</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-100 dark:divide-gray-700 dark:bg-darkmodeColor">
                                    {weights.map((weight, index) => (
                                        <tr
                                            key={weight.id}
                                            className={`hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150 ${index % 2 === 0
                                                ? 'bg-white dark:bg-darkmodeColor'
                                                : 'bg-gray-50/30 dark:bg-[rgba(1,14,78,0.8)]'
                                                }`}
                                        >
                                            <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>{weight.seller_id}</td>
                                            <td
                                                className="relative group p-2 text-xs text-gray-700 dark:text-gray-300  hover:text-blue-800 dark:hover:text-blue-300 font-medium transition-colors"
                                            >
                                                {weight.waybill}
                                            </td>
                                            <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>{weight.initial_weight}</td>
                                            <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>{weight.dimension}</td>
                                            <td className='p-2'>
                                                {weight.product_des?.length > 20 ? (
                                                    <div className="group relative">
                                                        <span className="text-xs text-gray-700 dark:text-gray-300 font-medium cursor-pointer">
                                                            {weight.product_des.substring(0, 20)}...
                                                        </span>
                                                        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg shadow-xl opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                                                            {weight.product_des}
                                                            <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <span className="text-xs text-gray-700 dark:text-gray-300 font-medium">{weight.product_des}</span>
                                                )}
                                            </td>
                                            <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>{weight.sku}</td>
                                            <td className='p-2 text-xs text-gray-900 dark:text-gray-100 font-semibold'>{weight.reversed_weight}</td>
                                            <td className='p-2 text-xs text-gray-900 dark:text-gray-100 font-semibold'>₹{weight.price || 'N/A'}</td>
                                            <td className='p-2'>
                                                <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium tracking-normal transition-all duration-200 ${weight.status === 'Accept'
                                                    ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg shadow-green-500/25 hover:shadow-green-500/40'
                                                    : weight.status === 'Reject'
                                                        ? 'bg-gradient-to-r from-red-500 to-red-600 text-white shadow-lg shadow-red-500/25 hover:shadow-red-500/40'
                                                        : weight.status === 'close'
                                                            ? 'bg-gradient-to-r from-gray-500 to-gray-600 text-white shadow-lg shadow-gray-500/25 hover:shadow-gray-500/40'
                                                            : weight.status === 'Pending'
                                                                ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg shadow-amber-500/25 hover:shadow-amber-500/40'
                                                                : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400 border border-gray-200 dark:border-gray-700'
                                                    }`}>
                                                    <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${weight.status === 'Accept'
                                                        ? 'bg-white animate-pulse'
                                                        : weight.status === 'Reject'
                                                            ? 'bg-white'
                                                            : weight.status === 'close'
                                                                ? 'bg-white'
                                                                : weight.status === 'Pending'
                                                                    ? 'bg-white animate-bounce'
                                                                    : 'bg-gray-400 dark:bg-gray-500'
                                                        }`}></span>
                                                    {weight.status}
                                                </span>
                                            </td>
                                            <td className='p-2 text-xs text-gray-700 dark:text-gray-300 font-medium'>{weight.timestamp}</td>
                                            <td className='p-2'>
                                                <div className='flex items-center gap-1'>
                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        onClick={() => handleViewClick(weight)}
                                                        color="primary"
                                                        className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
                                                        style={{
                                                            backgroundColor: '#3b82f6',
                                                            '&:hover': { backgroundColor: '#2563eb' }
                                                        }}
                                                    >
                                                        <IoMdEye className="text-xs" />
                                                    </Button>
                                                    <Button
                                                        onClick={() => handleAccept(weight)}
                                                        variant="contained"
                                                        color="success"
                                                        size="small"
                                                        disabled={weight.status === "Accept" || weight.status === "close"}
                                                        className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
                                                        style={{
                                                            backgroundColor: '#10b981',
                                                            '&:hover': { backgroundColor: '#059669' }
                                                        }}
                                                    >
                                                        <MdCheckCircle className="text-xs" />
                                                    </Button>
                                                    <Button
                                                        onClick={() => handleReject(weight)}
                                                        variant="contained"
                                                        color="error"
                                                        size="small"
                                                        disabled={weight.status === "Accept" || weight.status === "close"}
                                                        className="min-w-0 p-1 rounded-md shadow-sm hover:shadow-md transition-shadow"
                                                        style={{
                                                            backgroundColor: '#ef4444',
                                                            '&:hover': { backgroundColor: '#dc2626' }
                                                        }}
                                                    >
                                                        <MdCancel className="text-xs" />
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="mt-4 flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
                            <span className="text-sm text-gray-700 font-bold dark:text-gray-300">{`Total Weight: ${totalOrders}`}</span>
                            <select
                                id="limit"
                                value={limit}
                                onChange={handleLimitChange}
                                className="border rounded p-1 sm:ml-[480px] text-sm bg-white dark:bg-darkmodeColor dark:text-gray-200"
                            >
                                <option value={10}>10</option>
                                <option value={15}>15</option>
                                <option value={20}>20</option>
                                <option value={totalOrders}>All</option>
                            </select>
                            <Pagination
                                count={Math.ceil(totalOrders / limit)}
                                page={page}
                                onChange={handlePaginationChange}
                                variant="outlined"
                                shape="rounded"
                                className="pagination"
                                size="small"
                                renderItem={(item) => (
                                    <PaginationItem
                                        {...item}
                                        className={`mx-1 rounded-md ${item.selected ? 'bg-customPurple text-white' : 'text-gray-700 dark:text-gray-300'} hover:bg-purple-700 hover:text-white`}
                                    />
                                )}
                            />
                        </div>
                    </div>
                </div>
                <ViewWeightDisputes isopen={isPopupOpen} onClose={handleClose} allWeightDisputes={selectedweight} />
            </div>
        </>
    );
};

export default AllWeightDisputes;